import React, { useEffect, useContext } from 'react'
import { ReactSVG } from 'react-svg'
import { Grid, Container, Icon, Image, Table, TableCell, TableBody } from 'semantic-ui-react'
import { useDispatch } from 'react-redux'

import { InvertedButton, BodyContainer, Projects, ProjectsIcon, PartnerIcon, NormalHeader, MapContainer, Map, MainPageFullWidthBackgroundContainer, CertsImageContainer, CertsBackgroundContainer, SVGWrapper, CalendarHeaderCover, CalendarDownloadButtonsCover, SecondaryButton, ServicesHeaderCover, HorizontalStyledDiv, ProjectsRow, VerticalCenterLine, ProjectButton, FlexDiv, HiddenWideMobileTable, HiddenSmallMobileTable } from './style'

import ThemeContext, { themes } from '@/theme/context'

import { Reviews } from './Reviews'

export const BodyComponent = (props) => {
    const { drupalHost } = props
    const { primaryColor } = useContext(ThemeContext);
    const dispatch = useDispatch<any>();

    return (<>
        <CertsBackgroundContainer>
            <CertsImageContainer>
                <Image src='/themes/defaultNiimko/images/new/certs.png'/>
            </CertsImageContainer>
            <Container>
                <Grid stackable>
                    <Grid.Row>
                        <Grid.Column width={8}>
                            <Image className='hiddenDesktop' src='/themes/defaultNiimko/images/new/certs.png' />
                        </Grid.Column>
                        <Grid.Column width={8}>
                            <p>
                                <InvertedButton href={`//cert.${drupalHost}`} basic secondary inverted>
                                    Реестр сертификатов
                                </InvertedButton></p>
                            <p>
                            В&nbsp;реестре представлена информация о&nbsp;сертификатах качества, полученных образовательными организациями по&nbsp;итогам успешного прохождения внешней независимой оценки качества подготовки студентов, а также именные сертификаты студентов
                            </p>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        </CertsBackgroundContainer>
        <BodyContainer>
            <div id="services" style={{
                position: 'absolute',
                marginTop: '-45px'
            }}/>
            <ServicesHeaderCover>
                <NormalHeader>Система оценки качества образования</NormalHeader>
                <div>
                    <SecondaryButton
                        basic
                        floated='right'
                        $color={primaryColor}
                        onClick={() => dispatch({ type: 'TOGGLE_WIZARD' })}
                    >Помощник в выборе сервиса</SecondaryButton>
                </div>
            </ServicesHeaderCover>
            <Projects className="hiddenDesktop">
                <HiddenSmallMobileTable unstackable>
                    <TableBody>
                        <ProjectsRow columns={3}>
                            <TableCell colSpan={3}>
                                <FlexDiv>
                                    <HorizontalStyledDiv $color={primaryColor}>
                                        <span>Внешние системы оценивания</span>
                                    </HorizontalStyledDiv>
                                    <HorizontalStyledDiv $color={primaryColor}>
                                        <span>Внутренние системы оценивания</span>
                                    </HorizontalStyledDiv>
                                </FlexDiv>
                            </TableCell>
                        </ProjectsRow>
                        <ProjectsRow columns={3}>
                            <TableCell width={7}></TableCell>
                            <TableCell width={2} textAlign='center' verticalAlign='middle'>
                                <VerticalCenterLine className='first' $color={primaryColor}>Вход</VerticalCenterLine>
                            </TableCell>
                            <TableCell width={7}>
                                <ProjectButton basic href={`//diag.${drupalHost}`} $color={themes.diag.primaryColor}>
                                    <img src="/themes/defaultNiimko/images/new/icons/diag.svg" />
                                    <span>Диагностика</span>
                                </ProjectButton>
                                <p>Оценка уровня базовой и психологической подготовки первокурсников к продолжению обучения</p>
                            </TableCell>
                        </ProjectsRow>
                        <ProjectsRow>
                            <TableCell>
                                <ProjectButton basic href={`//fepo.${drupalHost}`} $color={themes.fepo.primaryColor}>
                                    <img src="/themes/defaultNiimko/images/new/icons/fepo.svg" />
                                    <span>ФЭПО</span>
                                </ProjectButton>
                                <p>Независимая оценка уровня образовательных достижений студентов в соответствии с требованиями ФГОС</p>
                            </TableCell>
                            <TableCell rowSpan={2} textAlign='center' verticalAlign='middle'>
                                <VerticalCenterLine $color={primaryColor}>Процесс обучения</VerticalCenterLine>
                            </TableCell>
                            <TableCell>
                                <ProjectButton basic href={`//fepo.${drupalHost}/fepo_pro`} $color={themes.fepo_pro.primaryColor}>
                                    <img src="/themes/defaultNiimko/images/new/icons/fepo_pro.svg" />
                                    <span>ФЭПО-pro</span>
                                </ProjectButton>
                                <p>Сертификационный экзамен, оценка уровня фундаментальной подготовки студентов по окончании 2-го курса</p>
                            </TableCell>
                        </ProjectsRow>
                        <ProjectsRow>
                            <TableCell>
                                <ProjectButton basic href={`//training.${drupalHost}`} $color={themes.ias.primaryColor}>
                                    <img src="/themes/defaultNiimko/images/new/icons/ias.svg" />
                                    <span>
                                        Тренажеры
                                        <div style={{
                                            position: 'absolute',
                                            fontSize: '.7em',
                                            lineHeight: '1em'
                                        }}>Тест-конструктор<br/> с нейросетями</div>
                                    </span>
                                </ProjectButton>
                                <p>Внутренний контроль результатов обучения, подготовка к процедурам внешнего контроля, разработка измерительных материалов</p>
                            </TableCell>
                            <TableCell>
                                <ProjectButton basic href={`//olymp.${drupalHost}`} $color={themes.olymp.primaryColor}>
                                    <img src="/themes/defaultNiimko/images/new/icons/olymp.svg" />
                                    <span>Олимпиады</span>
                                </ProjectButton>
                                <p>Оценка качества подготовки студентов на международном уровне</p>
                            </TableCell>
                        </ProjectsRow>
                        <ProjectsRow>
                            <TableCell>
                                <ProjectButton basic href={`//tfieb.${drupalHost}`} $color={themes.tfieb.primaryColor}>
                                    <img src="/themes/defaultNiimko/images/new/icons/tfieb.svg" />
                                    <span>Тренажер ФИЭБ</span>
                                </ProjectButton>
                                <p>Система целенаправленной подготовки к ФИЭБ</p>
                            </TableCell>
                            <TableCell textAlign='center' verticalAlign='middle'>
                                <VerticalCenterLine className='last' $color={primaryColor}>Выход</VerticalCenterLine>
                            </TableCell>
                            <TableCell>
                                <ProjectButton basic href={`//bakalavr.${drupalHost}`} $color={themes.fieb.primaryColor}>
                                    <img src="/themes/defaultNiimko/images/new/icons/fieb.svg" />
                                    <span>ФИЭБ</span>
                                </ProjectButton>
                                <p>Независимая оценка уровня подготовки выпускников в соответствии c требованиями ФГОС ВО</p>
                            </TableCell>
                        </ProjectsRow>
                    </TableBody>
                </HiddenSmallMobileTable>
                <HiddenWideMobileTable unstackable className=''>
                    <TableBody>
                        <ProjectsRow columns={2}>
                            <TableCell colSpan={2}>
                                <FlexDiv>
                                    <HorizontalStyledDiv $color={primaryColor}>
                                        <span>Внешние системы оценивания</span>
                                    </HorizontalStyledDiv>
                                </FlexDiv>
                            </TableCell>
                        </ProjectsRow>
                        <ProjectsRow>
                            <TableCell rowSpan={2} width={2} textAlign='center' verticalAlign='middle'>
                                <VerticalCenterLine $color={primaryColor}>Процесс обучения</VerticalCenterLine>
                            </TableCell>
                            <TableCell width={14}>
                                <ProjectButton basic href={`//fepo.${drupalHost}`} $color={themes.fepo.primaryColor}>
                                    <img src="/themes/defaultNiimko/images/new/icons/fepo.svg" />
                                    <span>ФЭПО</span>
                                </ProjectButton>
                                <p>Независимая оценка уровня образовательных достижений студентов в соответствии с требованиями ФГОС</p>
                            </TableCell>
                        </ProjectsRow>
                        <ProjectsRow>
                            <TableCell>
                                <ProjectButton basic href={`//training.${drupalHost}`} $color={themes.ias.primaryColor}>
                                    <img src="/themes/defaultNiimko/images/new/icons/ias.svg" />
                                    <span>
                                    <div>
                                        Тренажеры
                                    </div>
                                    <div style={{
                                        marginTop: '8px',
                                    }}>Тест-конструктор<br/> с нейросетями</div>
                                    </span>
                                </ProjectButton>
                                <p>Внутренний контроль результатов обучения, подготовка к процедурам внешнего контроля, разработка измерительных материалов</p>
                            </TableCell>
                        </ProjectsRow>
                        <ProjectsRow>
                            <TableCell textAlign='center' verticalAlign='middle'>
                                <VerticalCenterLine className='last' $color={primaryColor}>Выход</VerticalCenterLine>
                            </TableCell>
                            <TableCell>
                                <ProjectButton basic href={`//tfieb.${drupalHost}`} $color={themes.tfieb.primaryColor}>
                                    <img src="/themes/defaultNiimko/images/new/icons/tfieb.svg" />
                                    <span>Тренажер ФИЭБ</span>
                                </ProjectButton>
                                <p>Система целенаправленной подготовки к ФИЭБ</p>
                            </TableCell>
                        </ProjectsRow>
                    </TableBody>
                </HiddenWideMobileTable>
                <HiddenWideMobileTable unstackable>
                    <TableBody>
                        <ProjectsRow columns={2}>
                            <TableCell colSpan={2}>
                                <FlexDiv>
                                    <HorizontalStyledDiv $color={primaryColor}>
                                        <span>Внутренние системы оценивания</span>
                                    </HorizontalStyledDiv>
                                </FlexDiv>
                            </TableCell>
                        </ProjectsRow>
                        <ProjectsRow columns={2}>
                            <TableCell width={2} textAlign='center' verticalAlign='middle'>
                                <VerticalCenterLine className='first' $color={primaryColor}>Вход</VerticalCenterLine>
                            </TableCell>
                            <TableCell width={14}>
                                <ProjectButton basic href={`//diag.${drupalHost}`} $color={themes.diag.primaryColor}>
                                    <img src="/themes/defaultNiimko/images/new/icons/diag.svg" />
                                    <span>Диагностика</span>
                                </ProjectButton>
                                <p>Оценка уровня базовой и психологической подготовки первокурсников к продолжению обучения</p>
                            </TableCell>
                        </ProjectsRow>
                        <ProjectsRow>
                            <TableCell rowSpan={2} textAlign='center' verticalAlign='middle'>
                                <VerticalCenterLine $color={primaryColor}>Процесс обучения</VerticalCenterLine>
                            </TableCell>
                            <TableCell>
                                <ProjectButton basic href={`//fepo.${drupalHost}/fepo_pro`} $color={themes.fepo_pro.primaryColor}>
                                    <img src="/themes/defaultNiimko/images/new/icons/fepo_pro.svg" />
                                    <span>ФЭПО-pro</span>
                                </ProjectButton>
                                <p>Сертификационный экзамен, оценка уровня фундаментальной подготовки студентов по окончании 2-го курса</p>
                            </TableCell>
                        </ProjectsRow>
                        <ProjectsRow>
                            <TableCell>
                                <ProjectButton basic href={`//olymp.${drupalHost}`} $color={themes.olymp.primaryColor}>
                                    <img src="/themes/defaultNiimko/images/new/icons/olymp.svg" />
                                    <span>Олимпиады</span>
                                </ProjectButton>
                                <p>Оценка качества подготовки студентов на международном уровне</p>
                            </TableCell>
                        </ProjectsRow>
                        <ProjectsRow>
                            <TableCell textAlign='center' verticalAlign='middle'>
                                <VerticalCenterLine className='last' $color={primaryColor}>Выход</VerticalCenterLine>
                            </TableCell>
                            <TableCell>
                                <ProjectButton basic href={`//bakalavr.${drupalHost}`} $color={themes.fieb.primaryColor}>
                                    <img src="/themes/defaultNiimko/images/new/icons/fieb.svg" />
                                    <span>ФИЭБ</span>
                                </ProjectButton>
                                <p>Независимая оценка уровня подготовки выпускников в соответствии c требованиями ФГОС ВО</p>
                            </TableCell>
                        </ProjectsRow>
                    </TableBody>
                </HiddenWideMobileTable>
            </Projects>
                {/* <Grid>
                    <ProjectsRow>
                        <Grid.Column width={3}>
                            <Vertical $color={primaryColor}>
                                Внешние<br/>системы<br/>оценивания
                            </Vertical>
                        </Grid.Column>
                        <Grid.Column width={3}>
                            <SecondaryButton basic href={`//diag.${drupalHost}`} $color={themes.diag.primaryColor}>
                                <img src="/themes/defaultNiimko/images/new/icons/diag.svg" />
                                <div><span>Диагностика</span></div>
                            </SecondaryButton>
                        </Grid.Column>
                        <Grid.Column width={3}>
                            <SecondaryButton basic href={`//fepo.${drupalHost}/fepo_pro`} $color={themes.fepo_pro.primaryColor}>
                                <img src="/themes/defaultNiimko/images/new/icons/fepo_pro.svg" />
                                <div><span>ФЭПО-pro</span></div>
                            </SecondaryButton>
                        </Grid.Column>
                        <Grid.Column width={3}>
                            <SecondaryButton basic href={`//olymp.${drupalHost}`} $color={themes.olymp.primaryColor}>
                                <img src="/themes/defaultNiimko/images/new/icons/olymp.svg" />
                                <div><span>Олимпиады</span></div>
                            </SecondaryButton>
                        </Grid.Column>
                        <Grid.Column width={3}>
                            <SecondaryButton basic href={`//bakalavr.${drupalHost}`} $color={themes.fieb.primaryColor}>
                                <img src="/themes/defaultNiimko/images/new/icons/fieb.svg" />
                                <div><span>ФИЭБ</span></div>
                            </SecondaryButton>
                        </Grid.Column>
                    </ProjectsRow>
                    <ProjectsMiddleRow $color={primaryColor}>
                        <Grid.Column width={5} textAlign='center'>
                            <div>Вход</div>
                        </Grid.Column>
                        <Grid.Column width={6} textAlign='center'>
                            <div>Процесс обучения</div>
                        </Grid.Column>
                        <Grid.Column width={5} textAlign='center'>
                            <div>Выход</div>
                        </Grid.Column>
                    </ProjectsMiddleRow>
                    <ProjectsRow>
                        <Grid.Column width={3}>
                            <Vertical $color={primaryColor}>
                                Внутренние<br/>системы<br/>оценивания
                            </Vertical>
                        </Grid.Column>
                        <Grid.Column width={3}></Grid.Column>
                        <Grid.Column width={3}>
                            <SecondaryButton basic href={`//fepo.${drupalHost}`} $color={themes.fepo.primaryColor}>
                                <img src="/themes/defaultNiimko/images/new/icons/fepo.svg" />
                                <div><span>ФЭПО</span></div>
                            </SecondaryButton>
                        </Grid.Column>
                        <Grid.Column width={3}>
                            <SecondaryButton basic href={`//training.${drupalHost}`} $color={themes.ias.primaryColor}>
                                <img src="/themes/defaultNiimko/images/new/icons/ias.svg" />
                                <div><span>Тренажеры</span></div>
                            </SecondaryButton>
                        </Grid.Column>
                        <Grid.Column width={3}>
                            <SecondaryButton basic href={`//tfieb.${drupalHost}`} $color={themes.tfieb.primaryColor}>
                                <img src="/themes/defaultNiimko/images/new/icons/tfieb.svg" />
                                <div><span>Тренажер ФИЭБ</span></div>
                            </SecondaryButton>
                        </Grid.Column>
                    </ProjectsRow>
                </Grid> */}
            <Projects className="hiddenMobile">
                <SVGWrapper>
                    <ReactSVG src="/themes/defaultNiimko/images/new/projects.svg"/>
                </SVGWrapper>
                <ProjectsIcon $top='30%' $left='18%' $color={themes.diag.primaryColor}>
                    <a href={`//diag.${drupalHost}`}>
                        <img src="/themes/defaultNiimko/images/new/icons/diag.svg"/>
                        <div><span>Диагностика</span></div>
                    </a>
                </ProjectsIcon>
                <ProjectsIcon $top='39%' $left='37%' $color={themes.fepo.primaryColor}>
                    <a href={`//fepo.${drupalHost}`}>
                        <img src="/themes/defaultNiimko/images/new/icons/fepo.svg"/>
                        <div><span>ФЭПО</span></div>
                    </a>
                </ProjectsIcon>
                <ProjectsIcon $top='63%' $left='35%' $color={themes.fepo_pro.primaryColor}>
                    <a href={`//fepo.${drupalHost}/fepo_pro`}>
                        <img src="/themes/defaultNiimko/images/new/icons/fepo_pro.svg"/>
                        <div><span>ФЭПО-pro</span></div>
                    </a>
                </ProjectsIcon>
                <ProjectsIcon $top='47%' $left='50%' $color={themes.ias.primaryColor}>
                    <a href={`//training.${drupalHost}`}>
                        <img src="/themes/defaultNiimko/images/new/icons/ias.svg"/>
                        <div><span>Тренажеры</span></div>
                    </a>
                </ProjectsIcon>
                <ProjectsIcon $top='63%' $left='65%' $color={themes.olymp.primaryColor}>
                    <a href={`//olymp.${drupalHost}`}>
                        <img src="/themes/defaultNiimko/images/new/icons/olymp.svg"/>
                        <div><span>Олимпиады</span></div>
                    </a>
                </ProjectsIcon>
                <ProjectsIcon $top='39%' $left='63%' $color={themes.test_constructor.primaryColor} $revertMobile>
                    <a href={`//training.${drupalHost}/test_constructor`}>
                        <img src="/themes/defaultNiimko/images/new/icons/test_constructor.svg?ai"/>
                        <div><span>Тест-Конструктор<br/> с нейросетями</span></div>
                    </a>
                </ProjectsIcon>
                <ProjectsIcon $top='17%' $left='69%' $color={themes.tfieb.primaryColor} $revertMobile>
                    <a href={`//tfieb.${drupalHost}`}>
                        <img src="/themes/defaultNiimko/images/new/icons/tfieb.svg"/>
                        <div><span>Тренажер ФИЭБ</span></div>
                    </a>
                </ProjectsIcon>
                <ProjectsIcon $top='31%' $left='81%' $color={themes.fieb.primaryColor}>
                    <a href={`//bakalavr.${drupalHost}`}>
                        <img src="/themes/defaultNiimko/images/new/icons/fieb.svg"/>
                        <div><span>ФИЭБ</span></div>
                    </a>
                </ProjectsIcon>
            </Projects>
        </BodyContainer>
        <MainPageFullWidthBackgroundContainer>
            <BodyContainer>
                <CalendarHeaderCover>
                    <NormalHeader inverted>Стоимость и сроки</NormalHeader>
                    <CalendarDownloadButtonsCover>
                        <InvertedButton href="/sites/default/files/projects_calendar_2025_2026.pdf" target="_blank" basic secondary inverted floated="right">
                            <Icon name='file pdf outline' />
                            на&nbsp;2025 скачать
                        </InvertedButton>
                    </CalendarDownloadButtonsCover>
                </CalendarHeaderCover>
                <SVGWrapper className='hiddenMobile'>
                    <ReactSVG src='/themes/defaultNiimko/images/new/calendar.svg'/>
                </SVGWrapper>
            </BodyContainer>
        </MainPageFullWidthBackgroundContainer>
        <BodyContainer>
            <div id="partners" style={{
                position: 'absolute',
                marginTop: '-45px'
            }} />
            <NormalHeader>Наши партнеры</NormalHeader>
            <MapContainer>
                <Map src='/themes/defaultNiimko/images/new/map.png'/>
                <PartnerIcon $top='0%' $left='5%'>
                    <a href="https://fasie.ru/" target="_blank">
                        <img src="/themes/defaultNiimko/images/new/icons/partners/fond_sodeystvija_innovatsijam.svg"/>
                    </a>
                </PartnerIcon>
                <PartnerIcon $top='23%' $left='0%'>
                    <a href="https://mgsu.ru/universityabout/UMO-ASV/asv/" target="_blank">
                        <img src="/themes/defaultNiimko/images/new/icons/partners/mgsu.svg"/>
                    </a>
                </PartnerIcon>
                <PartnerIcon $top='28%' $left='29%'>
                    <a href="https://raex-rr.com/" target="_blank">
                        <img src="/themes/defaultNiimko/images/new/icons/partners/RAEX.svg"/>
                    </a>
                </PartnerIcon>
                <PartnerIcon $top='76%' $left='51%'>
                    <a href="https://2035.university/" target="_blank">
                        <img src="/themes/defaultNiimko/images/new/icons/partners/universitet_2035.svg"/>
                    </a>
                </PartnerIcon>
                <PartnerIcon $top='16%' $left='17%'>
                    <a href="https://idpo.volgatech.net/" target="_blank">
                        <img src="/themes/defaultNiimko/images/new/icons/partners/idpo_volgatech.svg"/>
                    </a>
                </PartnerIcon>
                <PartnerIcon $top='43%' $left='10%'>
                    <a href="https://dim.gov.az/en" target="_blank">
                        <img src="/themes/defaultNiimko/images/new/icons/partners/secra.svg"/>
                    </a>
                </PartnerIcon>
                <PartnerIcon $top='83%' $left='36%'>
                    <a href="http://vuzvestnik.ru/" target="_blank">
                        <img src="/themes/defaultNiimko/images/new/icons/partners/vuzovski_vestnik.png"/>
                    </a>
                </PartnerIcon>
                <PartnerIcon $top='48%' $left='25%'>
                    <a href="https://vovr.elpub.ru/jour?locale=ru_RU" target="_blank">
                        <img src="/themes/defaultNiimko/images/new/icons/partners/obrazovanie_v_rossii.svg"/>
                    </a>
                </PartnerIcon>
                <PartnerIcon $top='62%' $left='0%'>
                    <a href="https://iaea.info/" target="_blank">
                        <img src="/themes/defaultNiimko/images/new/icons/partners/IAEA.svg"/>
                    </a>
                </PartnerIcon>
                <PartnerIcon $top='83%' $left='8%'>
                    <a href="https://www.portalspo.ru/" target="_blank">
                        <img src="/themes/defaultNiimko/images/new/icons/partners/spo.png"/>
                    </a>
                </PartnerIcon>
                <PartnerIcon $top='83%' $left='67%'>
                    <a href="https://vestniknews.ru/" target="_blank">
                        <img src="/themes/defaultNiimko/images/new/icons/partners/vestnik_obrazovanija_v_rossii.png"/>
                    </a>
                </PartnerIcon>
                <PartnerIcon $top='-4%' $left='70%'>
                    <img src="/themes/defaultNiimko/images/new/icons/partners/vuz.svg"/>
                </PartnerIcon>
                <PartnerIcon $top='61%' $left='62%'>
                    <a href="https://eaoko.org/ru/" target="_blank">
                        <img src="/themes/defaultNiimko/images/new/icons/partners/EAOKO.png"/>
                    </a>
                </PartnerIcon>
                <PartnerIcon $top='59%' $left='41%'>
                    <a href="https://hetoday.ru/recommendations" target="_blank">
                        <img src="/themes/defaultNiimko/images/new/icons/partners/vysshee_obrazovanie_segodnya.svg"/>
                    </a>
                </PartnerIcon>
                <PartnerIcon $top='53%' $left='76%'>
                    <a href="http://www.pedagogika-rao.ru/" target="_blank">
                        <img src="/themes/defaultNiimko/images/new/icons/partners/pedagogika.svg"/>
                    </a>
                </PartnerIcon>
                <PartnerIcon $top='65%' $left='90%'>
                    <a href="https://panor.ru/magazines/rektor-vuza.html" target="_blank">
                        <img src="/themes/defaultNiimko/images/new/icons/partners/rektor_vuza.png"/>
                    </a>
                </PartnerIcon>
                <PartnerIcon $top='81%' $left='81%'>
                    <a href="https://testcenter.kz/ru/" target="_blank">
                        <img src="/themes/defaultNiimko/images/new/icons/partners/ntst.png" />
                    </a>
                </PartnerIcon>
                <PartnerIcon $top='0%' $left='26%'>
                    <a href="https://ioe.hse.ru/monitoring/" target="_blank">
                        <img src="/themes/defaultNiimko/images/new/icons/partners/tspio.png" />
                    </a>
                </PartnerIcon>
                <PartnerIcon $top='71%' $left='21%'>
                    <a href="https://rr-edu.ru/" target="_blank">
                        <img src="/themes/defaultNiimko/images/new/icons/partners/qaerr.png" />
                    </a>
                </PartnerIcon>
            </MapContainer>
        </BodyContainer>
        <BodyContainer>
            <Reviews {...props} />
        </BodyContainer>
    </>)
}
